import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { DriverService } from '../shared/driver.service';
import { NavigationService } from '../../shared/services/navigation.service';
import {UserSearchCriteria} from '../../shared/user-search-criteria';

@Component({
  selector: 'app-driver-list',
  templateUrl: './driver-list.component.html',
  styleUrls: ['./driver-list.component.scss']
})
export class DriverListComponent implements OnInit {

  filters = new UserSearchCriteria();

  loadPage = (page: number, pageSize: number) => this.driverService.searchByOwnCarrier(page, pageSize, this.filters);

  constructor(private userService: UserService,
              private driverService: DriverService,
              private navigation: NavigationService,
  ) {
  }

  ngOnInit() {
  }

  goToCreateDriver(): void {
    this.navigation.selfCarrier()
      .drivers()
      .create()
      .go();
  }

  goToEditDriver(id: string): void {
    this.navigation.selfCarrier()
      .drivers()
      .edit(id)
      .go();
  }

  goToEditCarrier(): void {
    this.navigation.selfCarrier()
      .editOwn()
      .go();
  }

  goToViewSubcontractors(): void {
    this.navigation.selfCarrier()
      .subcontractors()
      .list()
      .go();
  }
}
